import React from 'react';
import Navbar from '../components/Navbar';
import GalleryGridSection from '../components/GalleryGridSection';

const GalleryPage = () => {
  return (
    <>
      <Navbar />
      <div className="flex flex-col pt-4 GalleryPage sm:ml-20 ml-0 mb-4">
        <GalleryGridSection />
      </div>
    </>
  );
};

export default GalleryPage;
